import { useQuery } from 'data-fetching-client';
import { GET_FLOW_REFERENCES } from 'automation-ui-management/queries/flowReferenceQueries';
export const useFlowReferences = ({
  flowId,
  includeInboundReferences,
  includeOutboundReferences,
  notifyOnNetworkStatusChange = false,
  skip
}) => {
  const {
    data: listMigrationData,
    loading: listMigrationLoading,
    error: listMigrationError,
    refetch: listMigrationRefetch,
    networkStatus: listMigrationNetworkStatus
  } = useQuery(GET_FLOW_REFERENCES, {
    variables: {
      flowId,
      includeInboundReferences,
      includeOutboundReferences
    },
    skip,
    notifyOnNetworkStatusChange
  });
  return {
    data: listMigrationData,
    loading: listMigrationLoading,
    error: listMigrationError,
    refetch: listMigrationRefetch,
    networkStatus: listMigrationNetworkStatus
  };
};